
import { mapState, mapMutations } from "vuex";
import _ from "underscore";
import uiGameInfo from "./components/ui-game-info";
import crashBet from "../components/crash-bet";

import { getCrashRound } from "@/api";

import historyGameColor from "../util/historyGameColor";

// game.crashPoint
export default {
	name: 'history',

	components: {
		"ui-game-info": uiGameInfo,
		"crash-bet": crashBet,
	},

	filters: {

	},


	data() {
		return {
			players: [],
			playersBetSum: 0,
			playersCount: 0,
			privateSeed: '',
			publicSeed: '',
		};
	},
	watch: {
	},
	computed: {
		...mapState(["user"]),
		currencyType() {
			return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
		},
		currencyTypeLabel() {
			if (this.currencyType === 1) return '欢乐豆';
			if (this.currencyType === 2) return '金豆';
			return '现金';
		},
	},
	created() {
		this.fetchCrashRound()

	},
	mounted() {

	},

	beforeDestroy() {
	},

	methods: {

		...mapMutations([""]),

		async fetchCrashRound() {
			try {
				let id = this.$route.params.id;
				// console.log(1111, this.$route.params) : '6ad7ef9f-b1aa-45af-af2b-adde2dfddae9' }
				const data = await getCrashRound({ id, currencyType: this.currencyType });
				console.log("fetchCrashRound data:", data);
				this.players = data?.data.data.players
				this.playersBetSum = data?.data.data.playersBetSum
				this.playersCount = data?.data.data.playersCount
				this.privateSeed = data?.data.data.privateHash
				this.publicSeed = data?.data.data.privateSeed

			} catch (error) {
				console.log("There was an error while loading crash schema:", error);
			}
		},
		historyGameColor

	}
}
